import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class Frui_planPage extends Component {
  static propTypes = {
    furui: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

   componentDidMount() {
    const { frui_qpgoodsPage, currentFrui_qpgoods } = this.props.furui;
    this.fetchList(frui_qpgoodsPage);
  }

  fetchList = (page, values) => {
    const { getFrui_qpgoodsList } = this.props.actions;
    let params = Object.assign({}, { page: page }, values)
    getFrui_qpgoodsList(params);
  }

  getDataSource() {
    const { furui } = this.props;
    const { frui_qpgoodsById, frui_qpgoodsList } = furui;
    if (!frui_qpgoodsList) return [];
    return frui_qpgoodsList.map(id => frui_qpgoodsById[id]);
  }

  get listProps() {
      const { furui, actions } = this.props
    const { getFrui_qpgoodsListPending, frui_qpgoodsTotal, frui_qpgoodsPage } = furui
    const { deleteFrui_qpgoods, chooseCurrentFrui_qpgoods, frui_qpgoodsModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpgoodsListPending,
      columns:[
       {
          title: "批号",
          dataIndex: 'ph',
          key: 'ph',
          width: 120,
        },{
          title: "内胆批号",
          dataIndex: 'bh',
          key: 'bh',
          width: 140,
        },{
          title: "规格型号",
          dataIndex: 'wybh',
          key: 'wybh',
          width: 120,
        },{
          title: "充装介质",
          dataIndex: 'gcrj',
          key: 'gcrj',
          width: 120,
        },{
          title: "制造日期",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "内胆设计壁厚",
          dataIndex: 'nftsjhd',
          key: 'nftsjhd',
          width: 120,
        },{
          title: "直径",
          dataIndex: 'ndttsjhd',
          key: 'ndttsjhd',
          width: 120,
        },{
          title: "压力",
          dataIndex: 'ndzj',
          key: 'ndzj',
          width: 120,
        },{
          title: "编号",
          dataIndex: 'ndqysyyl',
          key: 'ndqysyyl',
          width: 120,
        },{
          title: "类型",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "质量证明",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "电子标识",
          dataIndex: 'dzbs',
          key: 'dzbs',
          render: (text) => {
            return <div> <a href='https://file.daries.com.cn/image/newAdd/demo%E5%9B%BE%E7%89%87.pdf'>预览</a> <a>生成</a> </div>
          }
        },
      ],
      pagination: {
        total: frui_qpgoodsTotal,
        current: frui_qpgoodsPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
       handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpgoods(record);
          frui_qpgoodsModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpgoods(record.id).then((data) => {
            this.fetchList(frui_qpgoodsPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { furui,actions } = this.props
    const { currentFrui_plan, frui_planModalVisible,frui_planPage, frui_planModalType,submitFrui_planPending } = furui

    const { frui_planModalChange,submitFrui_plan } = actions;
    const editItem  = frui_planModalType === 'create' ? {} : currentFrui_plan
    return {
      item: frui_planModalType === 'create' ? {} : currentFrui_plan,
      visible: frui_planModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_planPending,
      title: `${
        frui_planModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "shopName",
          label: "商户名",
          // initialValue: editItem.shopName,
          widget: Input,
          required: true
        },
        {
          key: "score",
          label: "score",
          // initialValue: editItem.score,
          widget: Input,
          required: true
        },
        {
          key: "subAppid",
          label: "商户公众号id",
          // initialValue: editItem.subAppid,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitFrui_plan(Object.assign({},data,{})).then(data=> {
          frui_planModalChange(false,"create");
          this.fetchList(frui_planPage);
        })
      },
      onCancel() {
        frui_planModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,furui } = this.props
    const { currentFrui_plan,frui_planPage} = furui
    const { frui_planModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        frui_planModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,furui } = this.props
    const { currentFrui_plan,frui_planPage} = furui
    const { frui_planModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ frui_planModalChange(true,'create')}
            },
              {
                name:"导出",
                buttonProps:{
                },
                onClick:()=>{ frui_planModalChange(true,'create')}
            },
              {
                name:"导入",
                buttonProps:{
                    type:"dashed",
                    icon:"plus",
                },
                onClick:()=>{ frui_planModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    furui: state.furui,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_planPage);


// WEBPACK FOOTER //
// ./src/features/furui/Frui_planPage.js